// Column configuration for Visa Allocation
export const VISA_ALLOCATION_COLUMNS = [
  { key: 'serial', title: 'S.NO', searchable: false },
  { key: 'vrf_reference_number', title: 'VRF REFERENCE NO', searchable: true },
  { key: 'visa_provider_name', title: 'VISA PROVIDER NAME', searchable: true },
  { key: 'visa_block_number', title: 'VISA BLOCK NUMBER', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'sponsor_id', title: 'SPONSOR ID', searchable: true },
  { key: 'Nationality', title: 'NATIONALITY', searchable: true },
  { key: 'ajeer', title: 'AJEER', searchable: false },
  { key: 'total_visa', title: 'TOTAL VISAS', searchable: false },
  { key: 'allocated', title: 'ALLOCATED', searchable: false },
  { key: 'unallocated', title: 'UNALLOCATED', searchable: false },
  { key: 'visa_return_requested_qty', title: 'UNDER REVERSAL', searchable: false },
  { key: 'visa_return_approval_qty', title: 'REVERSED', searchable: false },
  { key: 'action', title: 'ACTION', searchable: false },
  { key: 'Visa_Status', title: 'STATUS', searchable: true },
];

export const VISA_ALLOCATION_CONFIG = {
  API_ENDPOINT: "/dashboard/visa-stock/summary",
  DOWNLOAD_ENDPOINT: "/dashboard/visa-stock/StocksummaryExcel",
  DOWNLOAD_FILENAME: "VRF_Visa_Stock_Summary",
  SEARCH_PLACEHOLDER: "Search across all columns...",
  NO_DATA_MESSAGE: "No visa allocation data found",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000],
};

export const VISA_ALLOCATION_SEARCHABLE_FIELDS = VISA_ALLOCATION_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);
